module.exports = __webpack_public_path__ + "img/184.2281ecf2.jpg";